<template>
  <div id="modify_login_pwd">
    <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="118px" class="demo-ruleForm auth_form" >
      <!--      <el-form-item v-if="auth_state === 0" label="上传身份证人像面照片（仅支持jpg.png.格式照片）：" class="id_card_pic" prop="id_card_pic">
              <div class="id_card_pic_label" slot="label">上传身份证人像面照片 <span>（仅支持jpg.png.格式照片）</span></div>
              <div class="id_card_pic_ground">
                <div id="front">
                  <el-upload
                    v-loading="loading"
                    customClass="rName-uploader"
                    action
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="frontAvatarUpload">
                    <img v-if="frontUrl" :src="frontUrl" class="rName">
                    <i v-else class="el-icon-plus rName-uploader-icon rName-uploader-icon_front "></i>
                    <el-button size="small" type="primary" class="rName-upload-btn">上传人像面</el-button>
                  </el-upload>
                </div>
              </div>
              <div id="tips">点击选择图片（需小于5M）</div>
            </el-form-item>-->
      <el-form-item label="手机号："  prop="ph_num" v-if="auth_state === 0">
        <div class="personal_info">
          {{infoForm.ph_num}}
        </div>
      </el-form-item>
      <el-form-item  label="真实姓名：" prop="r_name">
        <el-input placeholder="请输入真实姓名" v-model="infoForm.r_name" :disabled="auth_state === 1"></el-input>
      </el-form-item>
      <el-form-item  label="身份证号：" :prop="auth_state === 1?'':'id_num'" >
        <el-input placeholder="请输入真实身份证号码" v-model="infoForm.id_num" :disabled="auth_state === 1" ></el-input>
      </el-form-item>
      <el-form-item label="短信验证码："  prop="v_code" class="v_code" v-if="auth_state === 0">
        <el-input placeholder="请输入短信验证码" autocomplete="new-password" v-model="infoForm.v_code" class="v_code_input" :disabled="!getcode"></el-input>
        <div v-if="smsCode" :class="getcode?'v_code_btn':'v_code_btn v_code_btnDisable'" @click="smsSend(infoForm.ph_num)" >获取</div>
        <div v-else class="v_code_btn" id="smsFalse" >{{ smsTime }}s</div>
      </el-form-item>
      <el-form-item  label="" label-width="0" v-if="auth_state != 1" class="promise_item">
        <div class="promise_box">
          <el-checkbox v-model="infoForm.checked">本人承诺提交信息真实有效,并对因虚假信息所引发的一切后果承担全部法律责任</el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <div class="submit-row">
      <div v-if="auth_state === 1" disabled class="submit_btn verified_btn">已实名</div>
      <el-button v-else :class="['submit_btn',!infoForm.checked?'submit_btn_active':'']" @click="submitForm('infoForm')" :disabled="!infoForm.checked">立即认证</el-button>
    </div>
  </div>
</template>
<script>
import {apiUserVerifed, apiUploadAuth, apiuserInfo, apiSmsSend} from '@/request/API'
import * as imageConversion from 'image-conversion'


export default {
  name: '',
  props: {},
  components: {},
  data() {
    var validate = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (reg.test(value)) {
        this.getcode = true
        callback()
      } else {
        this.getcode = false
        callback(new Error('身份证号码格式错误!'));
      }
    };
    return {
      getcode:false,
      showInput: false,
      loading: false,
      //身份证 正
      frontUrl: '',
      //实名状态
      auth_state: 0,
      //表单信息
      infoForm: {
        v_code:'',
        r_name: this.$store.state.userData.cert_name,
        id_num: this.$store.state.userData.cert_id,
        ph_num: this.$store.state.userData.telphone,
        checked:false,
      },
      //表单验证
      rules: {
        v_code: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'}
        ],
        r_name: [
          {required: true, message: '请输入真实姓名', trigger: 'blur'}
        ],
        id_num: [
          {required: true, message: '请输入身份证号码', trigger: 'blur'},
          { validator: validate, trigger: ['change','blur'] }
        ],
      },
      //获取验证码
      smsCode:true,
      smsTime:60
    }
  },
  methods: {
    /**
     * 获取验证码
     * @param phone
     */
    smsSend(phone){
      if (!this.getcode) {
        return
      }
      apiSmsSend({
        phone:phone,
        codeType:this.$store.state.userData.country_code == '86'?14:14,
        country_code:this.$store.state.userData.country_code,
      }).then(res => {
        this.$message({
          type:"success",
          center:true,
          message:"发送成功"
        })
        this.smsCode = false
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })
    },
    /**
     * 提交表单
     * @param formName 表单名称
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiUserVerifed({
            cert_name: this.infoForm.r_name,
            cert_id: this.infoForm.id_num,
            smsCode:this.infoForm.v_code
          }).then(res => {
            this.$message({
              center: true,
              message: "提交成功",
              type: "success"
            })
            this.getBasicInfo()
            setTimeout(() => {
              if (this.$route.query.Rurl) {
                this.$router.go(-1)
              }
            }, 2000)
          }).catch(err => {
            this.$message({
              center: true,
              message: err.msg,
              type: "error"
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 上传身份证图片
     * @param file 图片信息
     * @returns {boolean} 图片格式是否符合要求
     */
    async frontAvatarUpload(file) {
      this.loading = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        this.loading = false
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 1024,
        type: 'image/jpeg'
      })
      this.$getBase64(newFile).then(res => {
        apiUploadAuth({
          file: res
        }).then(res => {
          this.$message({
            type: 'success',
            message: '验证成功',
            center: true
          })
          this.infoForm.r_name = res.data.cert_name
          this.infoForm.id_num = res.data.cert_id
          this.frontUrl = URL.createObjectURL(file.raw)
          this.loading = false

        }).catch(err => {
          this.$message({
            type: "error",
            message: err.msg,
            center: true
          })
          this.loading = false
        })
      });

      return isJPG;
    },
    getBasicInfo() {
      apiuserInfo({
        action: 'verified'
      }).then(res => {
        this.auth_state = res.data.auth_state
        this.infoForm.id_num = res.data.cert_id
        this.infoForm.r_name = res.data.cert_name
      })
    },
    //获取验证码冷却
    countdownTime(){
      this.smsTime--
      if(this.smsTime === 0){
        this.smsCode = true
      }
    }
  },
  mounted() {
    this.getBasicInfo()
    this.$nextTick(()=>{
      this.$refs.infoForm.clearValidate()
    })
  },
  watch: {
    smsCode(val, oldVal){//普通的watch监听
      if(!val){
        this.smsTime = 60
        this.countdown = setInterval(this.countdownTime, 1000);
      }else{
        clearInterval(this.countdown)
      }
    },
  },
  computed: {}
}
</script>

<style>
.rName-uploader .el-upload {
  height: 116px !important;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  /*overflow: hidden;*/
}

.rName-upload-btn {
  border-radius: 0 0 4px 4px;
  /*position: absolute;*/
  /*top: 114px;*/
  /*left: -1px;*/
  width: 173px;
  height: 40px;
  background: #1A1D24 !important;
  border: none;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  padding: 0;
  line-height: 40px;
  text-align: center;
}

.rName-upload-btn:hover {
  background: #1A1D24 !important;
}

.rName-uploader .el-upload:hover {
  border-color: var(--primary, #FF5A1F);
}

.rName-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 173px;
  height: 114px;
  line-height: 114px;
  text-align: center;
}

.rName-uploader-icon_front {
  background: url("../../../../assets/image/PersonalCenter/PersonalInfo/front.png");
}

.rName-uploader-icon_behind {
  background: url("../../../../assets/image/PersonalCenter/PersonalInfo/behind.png");
}

.rName {
  width: 173px;
  height: 114px;
  display: block;
}
</style>

<style lang='less' scoped>
/deep/ .el-upload {
  display: flex;
  flex-direction: column;
}

#modify_login_pwd {
  width: 100%;
  min-height: 520px;
  padding: 32px 44px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .auth_form {
    display: table;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }

  /deep/ .el-input {
    width: 360px;
    max-width: 100%;
  }

  /deep/ .el-input__inner {
    width: 100%;
    height: 40px;
    padding: 0 14px;
    background: var(--bg-tag, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  }

  /deep/ .el-input__inner:hover {
    border-color: var(--border-strong, #D8D2CA);
    background: #FFFFFF;
  }

  /deep/ .el-input__inner:focus {
    border-color: var(--primary, #FF5A1F);
    background: #FFFFFF;
    box-shadow: none;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    color: var(--text-secondary, #5A5F6B);
    background: var(--bg-tag, #F0EDE8);
    border-color: var(--border-soft, #E8E4DE);
  }

  /deep/ .is-error .el-input__inner {
    border-color: var(--danger, #EF4444);
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
  }

  /deep/ .el-form-item__label {
    padding: 0 16px 0 0;
    text-align: right;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 40px;
  }

  /deep/ .el-form-item {
    min-height: 40px;
    margin-bottom: 22px;
  }

  /deep/ .el-form-item__content {
    min-height: 40px;
    line-height: 40px;
  }

  /deep/ .el-form-item__error {
    padding-top: 5px;
    color: var(--danger, #EF4444);
  }

  .id_card_pic {
    display: flex;
    flex-direction: column;
  }

  .id_card_pic /deep/ .el-form-item__label {
    width: 355px !important;
    display: flex;
    flex-direction: row;
    align-items: center;

    .id_card_pic_label {
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: #5B5B5B;

      span {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #8F8F8F;
      }
    }
  }

  .id_card_pic /deep/ .el-form-item__content {
    //margin: 0 !important;
    .id_card_pic_ground {
      height: 116px !important;
      display: flex;
      flex-direction: row;

      #front {
        margin: 0 0 0 12px;
      }

      #behind {
        margin: 0 0 0 20px;
      }

      #handHeld {
        margin: 0 0 0 20px;
      }
    }

    #tips {
      margin: 50px 0 0 12px;
      font-size: 14px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 300;
      color: #8F8F8F;
      line-height: 20px;
    }
  }

  .v_code /deep/ .el-form-item__content {
    display: flex;
    align-items: flex-start;
  }

  .v_code_input,
  .v_code_input /deep/ .el-input__inner {
    width: 246px;
  }

  .v_code_btn{
    margin: 0 0 0 10px !important;
    width: 104px;
    height: 40px;
    border: 1.5px solid var(--bg-dark, #1A1D24);
    border-radius: 3px;
    background: #FFFFFF;
    color: var(--text-main, #1A1D24);
    cursor: pointer;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    line-height: 38px;
    transition: color .2s ease, background .2s ease, border-color .2s ease;
  }

  .v_code_btn:hover {
    border-color: var(--bg-dark, #1A1D24);
    background: var(--bg-tag, #F0EDE8);
  }

  .v_code_btnDisable{
    color: var(--text-muted, #9AA0AC);
    border-color: var(--border-soft, #E8E4DE);
    background: var(--bg-tag, #F0EDE8);
    cursor: not-allowed;
  }

  .v_code_btnDisable:hover {
    border-color: var(--border-soft, #E8E4DE);
    background: var(--bg-tag, #F0EDE8);
  }

  #smsFalse{
    color: var(--text-muted, #9AA0AC);
    border-color: var(--border-soft, #E8E4DE);
    background: var(--bg-tag, #F0EDE8);
    cursor: auto;
  }

  .personal_info{
    display: flex;
    width: 360px;
    max-width: 100%;
    min-height: 40px;
    align-items: center;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
  }

  .promise_item {
    width: 494px;
    max-width: 100%;
    margin: 0;
    padding-left: 118px;
  }

  .promise_item /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .promise_box {
    position: relative;
    width: 100%;
    min-height: 42px;
    padding: 10px 14px 10px 16px;
    border: none;
    border-radius: 4px;
    background: var(--primary-soft, #FCEDE5);
    line-height: 20px;
  }

  .promise_box:before {
    content: "";
    position: absolute;
    top: 12px;
    bottom: 12px;
    left: 0;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: var(--primary, #FF7A1A);
  }

  .promise_box /deep/ .el-checkbox {
    display: flex;
    align-items: flex-start;
    white-space: normal;
  }

  .promise_box /deep/ .el-checkbox__input {
    padding-top: 2px;
  }

  .promise_box /deep/ .el-checkbox__label {
    padding-left: 8px;
    color: var(--text-secondary, #5A5F6B);
    font-size: 13px;
    line-height: 20px;
    white-space: normal;
  }

  .promise_box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--primary, #FF7A1A);
    background: var(--primary, #FF7A1A);
  }

  .promise_box /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: var(--text-main, #111827);
  }

  .submit-row{
    width: 584px;
    max-width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .submit_btn {
    display: inline-flex;
    margin: 8px 0 0 0;
    width: 200px;
    height: 42px;
    padding: 0;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 3px;
    background: var(--primary, #FF5A1F);
    box-shadow: none;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
    line-height: 42px;
    transition: background .2s ease;
  }

  .submit_btn:hover {
    background: var(--primary-hover, #E84A12);
  }

  .submit_btn_active{
    background: var(--bg-tag, #F0EDE8);
    color: var(--text-muted, #9AA0AC);
    box-shadow: none;
    cursor: not-allowed;
  }

  .submit_btn_active:hover {
    box-shadow: none;
    opacity: 1;
  }

  /deep/ .el-button.is-disabled,
  /deep/ .el-button.is-disabled:hover,
  /deep/ .el-button.is-disabled:focus {
    border: none;
    background: var(--bg-tag, #F0EDE8);
    color: var(--text-muted, #9AA0AC);
  }

  .verified_btn {
    color: var(--success, #22C55E);
    background: var(--success-soft, #ECFDF5);
    box-shadow: none;
    cursor: default;
  }

  .verified_btn:hover {
    box-shadow: none;
    opacity: 1;
  }

}
</style>
